import React, { useState } from 'react';
import './CreateBackupModal.css';

const CreateBackupModal = ({
  backupType,
  districts,
  selectedDistrict,
  onDistrictChange,
  onCreate,
  onClose
}) => {
  const [creating, setCreating] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (backupType === 'district' && !selectedDistrict) {
      alert('Please select a district');
      return;
    }

    setCreating(true);
    try {
      await onCreate(backupType, selectedDistrict || null);
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            Create {backupType === 'full' ? 'Full Database' : 'District'} Backup
          </h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {backupType === 'full' ? (
              <div className="backup-info">
                <p>This will create a complete backup of the entire database.</p>
                <p className="backup-warning-text">
                  ⚠️ Full backups can be large and may take several minutes.
                </p>
              </div>
            ) : (
              <div className="backup-info">
                <p>This will create a backup of all data for the selected district.</p>
                <p className="backup-note">
                  ℹ️ District backups use JSON format and may be larger than SQL backups due to format verbosity.
                </p>
                <div className="form-group">
                  <label htmlFor="district-select">Select District:</label>
                  <select
                    id="district-select"
                    value={selectedDistrict}
                    onChange={(e) => onDistrictChange(e.target.value)}
                    required
                  >
                    <option value="">-- Select District --</option>
                    {districts.map((district) => (
                      <option key={district.id} value={district.id}>
                        {district.district_name} ({district.subdomain})
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary"
              disabled={creating}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={creating}
            >
              {creating ? 'Creating...' : 'Create Backup'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateBackupModal;
